import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

export interface Assessment {
  id: string
  site_name: string
  client_name?: string
  survey_date: string
  assessor_id: string
  assessor_name: string
  status: 'draft' | 'submitted' | 'completed'
  overall_risk_rating?: string
  form_data: Record<string, any>
  created_at: string
  updated_at: string
}

export interface TriggeredFinding {
  id: string
  assessment_id: string
  ref_number: number
  priority: 'P1' | 'P2' | 'P3' | 'H&S'
  finding: string
  remedial_action: string
  monitoring_task_added?: string
  created_at: string
}

export interface MonitoringTask {
  id: string
  assessment_id: string
  task_name: string
  frequency: string
  triggered_by_ref?: number
  baseline: boolean
  created_at: string
}
